import { AccusationSuccessScreenNavigationProps } from "./types"
import React from "react"
import AccusationSuccess from "./accusation-success-screen"
import { PageRoot } from "~screens/page-root"


const AccusationSuccessScreen: React.FC<AccusationSuccessScreenNavigationProps> = () => {
  return (
    <PageRoot>
      <AccusationSuccess />
    </PageRoot>
  )
}

export default AccusationSuccessScreen
